<template>
  <v-app>
    <!-- <keep-alive> -->
    <component :is="getThemeMode.layout" />

    <!-- </keep-alive> -->
  </v-app>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  export default {
    data () {
      return {
        layoutName: '',
      }
    },
    mounted () {
      console.log(localStorage.getItem('userInfo'))
    },
    computed: {
      ...mapGetters(['getThemeMode']),
    },
    // mounted() {
    //   if (this.$route.params.layout) {
    //     this.changeThemeLayout(this.$route.params.layout);
    //   }
    // },
    methods: {
      ...mapActions(['changeThemeLayout']),
    },
  }
</script>
